import firebase from 'firebase'
import {
  update, field, collection, get, query, where, set, add, remove,
} from 'typesaurus'
import { clone } from 'ramda'
import { db } from '../firebase/init'
import UUID from './system/uuid'
import { DisplaySlideType, SlideDetailsType } from '../types'
import { DisplaySlideDetails, DisplaySlideCollection } from './collections'
// img is Croppa Component Value


export function uploadImage(img:any, group:string, bucket:string) {
  return new Promise((resolve, reject) => {
    const id = UUID()
    console.log('id is: ', id, '---', img)
    img.generateBlob((blob:Blob) => {
      const fileType = blob.type.split('/')[1]
      console.log('here222', blob, ' -- asdf -- ', fileType)
      firebase.app().storage(bucket).ref(`/${group}/${id}.${fileType}`).put(blob)
        .then((result:any) => {
          console.log('result is: ', result)
          if (result.state === 'success') {
            resolve([result, id])
          } reject(Error('Error Uploading Image'))
        })
    })
  })
}

export async function addToBoard(slideId:string, boardId:string, addBoardToSlide:boolean = true, startTime = 0) {
  console.log('adding')
  const promises:any[] = []
  promises.push(db.collection('displayBoards').doc(boardId).update(
    {
      slides: firebase.firestore.FieldValue.arrayUnion(slideId),
    },
  ))
  promises.push(add(DisplaySlideDetails, {
    slide: slideId,
    startDate: null,
    endDate: null,
    duration: 10000,
    board: boardId,
    schedule: [{ start: startTime, end: startTime + 24 }, { start: startTime, end: startTime + 24 }, { start: startTime, end: startTime + 24 }, { start: startTime, end: startTime + 24 }, { start: startTime, end: startTime + 24 }, { start: startTime, end: startTime + 24 }, { start: startTime, end: startTime + 24 }],
  }))
  if (addBoardToSlide) {
    promises.push(db.collection('displaySlides').doc(slideId).update(
      {
        boards: firebase.firestore.FieldValue.arrayUnion(boardId),
      },
    ))
  }
  const result = await Promise.all(promises)
  console.log('result: ', result)
  return result
}

export async function removeFromBoard(slideId:string, boardId:string) {
  try {
    const promises:any[] = []
    promises.push(db.collection('displayBoards').doc(boardId).update(
      {
        slides: firebase.firestore.FieldValue.arrayRemove(slideId),
      },
    ))
    promises.push(db.collection('displaySlides').doc(slideId).update(
      {
        boards: firebase.firestore.FieldValue.arrayRemove(boardId),
      },
    ))
    promises.push(remove(DisplaySlideDetails, slideId))
    const result = await Promise.all(promises)
    return result
  } catch (e) {
    throw new Error('Error Removing Board')
  }
}

export async function createSlide(slidex:DisplaySlideType, image:any, group:string, boardId:string = '', boardStart = 0) {
  console.log('Slide: ', slidex)
  console.log('Image: ', image)
  console.log('Group: ', group)
  console.log('boardId: ', boardId)

  let imageData:any = {}
  let id = UUID()
  const slide = clone(slidex)
  try {
    if (slide.type === 'image') {
      const r:any = await uploadImage(image, group, 'gs://canvas-displays')
      // eslint-disable-next-line prefer-destructuring
      imageData = r[0]
      // eslint-disable-next-line prefer-destructuring
      id = r[1]
      console.log('here result is: ', id, ' --- ', imageData)
      delete slide.url
      if (imageData.state !== 'success' || !id) {
        throw new Error('Error Creating Image')
      }
    }
    slide.created = new Date()
    slide.updated = new Date()
    slide.boards = boardId ? [boardId] : []
    slide.active = true
    await set(DisplaySlideCollection, id, slide)
    if (boardId) {
      await addToBoard(id, boardId, false, boardStart)
    }
    return true
  } catch (e) {
    throw new Error(e)
  }
}

export async function updateSlide(slideDetailsId:string, details:SlideDetailsType) {
  try {
    await set(DisplaySlideDetails, slideDetailsId, details)
    return true
  } catch (e) {
    console.log('Error updating slides: ', e)
    throw new Error(e)
  }
}

export async function makeActive(slideId:string, active = true) {
  try {
    await update(DisplaySlideCollection, slideId, { active, updated: new Date() })
    return true
  } catch (e) {
    console.log('Error updating slides: ', e)
    throw new Error(e)
  }
}

export async function deleteSlide(slideId:string, boards:string[]) {
  try {
    const promises = []
    promises.push(remove(DisplaySlideCollection, slideId))
    boards.forEach((board:string) => {
      promises.push(db.collection('displayBoards').doc(board).update(
        {
          slides: firebase.firestore.FieldValue.arrayRemove(slideId),
        },
      ))
    })
    const slideDetails = await query(DisplaySlideDetails, [where('slide', '==', 'slideId')])
    slideDetails.forEach((details) => {
      promises.push(remove(DisplaySlideDetails, details.ref.id))
    })
    console.log('here promises is: ', promises)
    const results = await Promise.all(promises)
    console.log('results: ', results)
    return true
  } catch (e) {
    console.log('Error updating slides: ', e)
    throw new Error(e)
  }
}
